const breakPoints = {
  'screen-extra-small': 480,
  'screen-small': 576,
  'screen-medium': 760,
  'screen-large': 1025,
  'screen-extra-large': 1200,
};

const mediaQueries = (bP, widthLimit = 'min') => style =>
  `@media (${widthLimit}-width: ${breakPoints[bP] -
    (widthLimit === 'max' ? 1 : 0)}px) { ${style} }`;

export { mediaQueries };
